import {MutationTree} from "vuex";
import * as moment from "moment";

export const mutations: MutationTree<any> = {

    setFeedbackLoading(state: any, payload: any) {
        state.feedbackLoading = payload;
    },

    setFeedbackData(state: any, payload: any) {
        state.feedbackCacheExpires = moment().add(15, 'minutes');
        state.data = payload;
    },
};
